import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    mode: 'system',
};

const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        setThemeMode: (state, action) => {
            state.mode = action.payload;
        },
    },
});

export const { setThemeMode } = themeSlice.actions;
export default themeSlice.reducer;